import { addFilter, removeFilter } from '@wordpress/hooks';
import { withSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

import AdvancedGallery from './AdvancedGallery';

const AdvancedGalleryCB = ( content, allData ) => {
    return [ ...content, <AdvancedGallery allData={allData} /> ];
}

removeFilter( 'wptravel_trip_edit_tab_content_gallery', 'WPTravel/TripEdit/SimpleGallery' );
addFilter( 'wptravel_trip_edit_tab_content_gallery', 'WPTravelPro/TripEdit/AdvancedGallery', AdvancedGalleryCB, 10 );

removeFilter( 'wptravel_trip_edit_block_tab_gallery', 'WPTravel/TripEdit/Block/Gallery/SimpleGallery' );
addFilter( 'wptravel_trip_edit_block_tab_gallery', 'WPTravel/TripEdit/Block/Gallery/AdvancedGallery', AdvancedGalleryCB, 10 );

export default withSelect( (select ) => {
    // const { getMedia } = typeof select( 'core' ) != 'undefined' && select( 'core' ) != null ? select( 'core' ) : null;
    // const { getEditedPostAttribute } = select( 'core/editor' );
    // const featuredImageId = getEditedPostAttribute( 'featured_media' );

    // return {
    //     media: featuredImageId && typeof getMedia != 'undefined' && getMedia != null ? getMedia( featuredImageId ) : null,
    //     featuredImageId,
    // };
} ) ( AdvancedGallery );